export default {
  setCurrentWorkspaceId(workspaceId) {
    document.cookie = `workspace_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    localStorage.setItem("currentWorkspaceId", workspaceId);
    document.cookie = `workspace_id=${workspaceId}; path=/; max-age=31536000`;
  },
  getCurrentWorkspaceId() {
    return localStorage.getItem("currentWorkspaceId");
  },
  removeCurrentWorkspaceId() {
    localStorage.removeItem("currentWorkspaceId");
    document.cookie = `workspace_id=; path=/; max-age=0`;
  },
  isAiHr() {
    return window.location.href.includes("hr.superagi.com");
  },
};
